import { EnvType } from "../services";
import ApiClient from "../api-client";
import { UploadFileResponse } from "../Types/upload-file-response";
import { default as IUploadApiClient, default as UploadApiClient } from "../Upload/upload-api-client";

export default class UploadService {
  uploadApiClient: IUploadApiClient;
  constructor(envType: EnvType) {
    this.uploadApiClient = new UploadApiClient(new ApiClient(envType), envType);
  }

  async UploadBrowserFile(
    objectId: number,
    relativePath: string,
    file: File,
    abortSignal?: AbortSignal,
    onUploadProgressCallback?: (progressEvent: any) => void
  ): Promise<UploadFileResponse> {
    const formData = new FormData();
    formData.append("objectId", String(objectId));
    formData.append("relativePath", String(relativePath));
    formData.append("file", file);

    return this.uploadApiClient.UploadBrowserFile(formData, abortSignal, onUploadProgressCallback);
  }

  async UploadLegacyImporterFile(
    storageId: number,
    file: File,
    abortSignal?: AbortSignal,
    onUploadProgressCallback?: (progressEvent: any) => void
  ): Promise<UploadFileResponse> {
    const formData = new FormData();
    formData.append("objectId", String(0));
    formData.append("storageId", String(storageId));
    formData.append("file", file);

    return this.uploadApiClient.UploadBrowserFile(formData, abortSignal, onUploadProgressCallback);
  }

  //------Utils------
  GetServiceUrl(): string {
    return this.uploadApiClient.GetApiUrl();
  }
}
